import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function ForWhoSection() {
  const forWho = ['querés empezar a vender por internet', 'querés construir una fuente de ingresos propia', 'querés aprender Shopify sin ahogarte con lo técnico', 'ya intentaste vender antes y no te funcionó', 'tenés una idea, una marca o ganas de emprender, pero te falta estructura', 'querés una ruta más clara para acercarte a una vida con más tiempo y libertad'];
  const notForWho = ['buscás dinero fácil sin trabajar', 'no estás dispuesto a implementar', 'querés consumir teoría sin ejecutar', 'pretendés resultados sin constancia'];
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-99">
      <div className="max-w-6xl mx-auto" data-id="element-100">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-101">
          <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-2xl p-8 border-4 border-green-500" data-id="element-102">
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-8" data-id="element-103">
              Esto es para vos si…
            </h2>
            <div className="space-y-4" data-id="element-104">
              {forWho.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-105">
                  <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-106" />
                  <span className="text-lg text-gray-700" data-id="element-107">{item}</span>
                </div>)}
            </div>
          </div>

          <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-8 border-4 border-red-500" data-id="element-108">
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-8" data-id="element-109">
              Esto NO es para vos si…
            </h2>
            <div className="space-y-4" data-id="element-110">
              {notForWho.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-111">
                  <XIcon className="w-6 h-6 text-red-600 flex-shrink-0 mt-1" data-id="element-112" />
                  <span className="text-lg text-gray-700" data-id="element-113">{item}</span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}